import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useDispatch } from 'react-redux';

import { applySearchResultReport } from '@/store/slices/transmissionReports/transmissionReportsSlice';
import { routes } from '@/routes';

import { ReportColor } from '@/types/transmissionReport';

const LoadReport: React.FC = () => {
  const [searchParams] = useSearchParams();
  const reportIdParam = searchParams.get('reportId');
  const colorParam = searchParams.get('color') as ReportColor | null;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (reportIdParam && colorParam) {
      const reportId = Number(reportIdParam);
      if (!isNaN(reportId)) {
        dispatch(
          applySearchResultReport({
            reportId,
            color: colorParam,
            skipSelectedReportReset: true
          })
        );
      } else {
        console.error('Invalid reportId:', reportIdParam);
      }
      // Navigate after dispatching the action.
      navigate(routes.physician.editReportById(reportIdParam));
    } else {
      console.error('Missing required query parameters: reportId or color');
    }
  }, [reportIdParam, colorParam, dispatch, navigate]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        color: 'plum'
      }}>
      {reportIdParam && colorParam ? (
        <p>
          Loading report with ID: {reportIdParam} and color: {colorParam}
        </p>
      ) : (
        <p>Missing required query parameters: reportId or color</p>
      )}
    </div>
  );
};

export default LoadReport;
